import Parallax from "parallax-js";
$(document).on(
  "tqht_mansite_news_event rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    if ($("#blockHomeBannerSwiper").length > 0) {
      const swiperBanner = new Swiper('#blockHomeBannerSwiper', {
        slidesPerView: 1,
        centeredSlides: true,
        // autoplay: {
        //   delay: 5000,
        // },
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: '.swiper-pagination--blockHomeBannerSwiper',
          clickable: true,
        },
      });
    }
    
    
  }
);
